module.exports = __webpack_public_path__ + "img/11.68516121.png";